import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import { initScroll } from "./lib/scroll.js";
import { initHeader } from "./lib/header";
import { initEvents } from "./lib/events";
import { initAccordions } from "./lib/components/accordions";
import { initSlideshows } from "./lib/components/slideshows";
import { initPhotoGallery } from "./lib/components/photo-gallery";
import { initAboutLayouts } from "./lib/components/about-layout";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	if (!document.querySelector("body.wp-admin")) {
		initScroll();
	}
	new BetterMenu();
	new BetterModal();
	initHeader();
	initEvents();
	initAccordions();
	initSlideshows();
	initPhotoGallery();
	initAboutLayouts();
});
